export const AUTH_STATES = Object.freeze({
  AUTH_LOADING: "AUTH_LOADING",
  SIGNED_OUT: "SIGNED_OUT",
  PROFILE_REQUIRED: "PROFILE_REQUIRED",
  READY: "READY",
});

export function resolveAuthState(firebaseUser, profileExists) {
  if (firebaseUser === undefined) return AUTH_STATES.AUTH_LOADING;
  if (!firebaseUser) return AUTH_STATES.SIGNED_OUT;
  if (profileExists === undefined) return AUTH_STATES.AUTH_LOADING;
  return profileExists ? AUTH_STATES.READY : AUTH_STATES.PROFILE_REQUIRED;
}
